( function( global, $ ) {
    "use strict";

    var _events = {
        onChangeSubdivisionCode: function(ev) {
            ev.preventDefault();

            var $this = $(this),
                $form = $(this.form),
                subdivision = $this.val(),
                $regionCode = $form.find('[data-region-code]'),
                $regionCodeField = $regionCode.closest('[data-form-field="region-code"]'),
                isQuebec = subdivision && subdivision === 'CA-QC';

            $regionCodeField.toggleClass('hidden', ! isQuebec);

            if (! isQuebec) {
                $regionCode.val('');

                if ($regionCode[0] && $regionCode[0].selectize) {
                    $regionCode[0].selectize.setValue('');
                }
            }
        },

        onChangeCountry: function(ev) {
            ev.preventDefault();

            var $form = $(this.form),
                $dataRegionCodes = $form.find('[data-region-code]');

            $dataRegionCodes.val('');
        }
    };

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container);

        $container.find('[data-subdivision-code]').on('change', _events.onChangeSubdivisionCode);
        $container.find('[data-country]').on('change', _events.onChangeCountry);
    });

}( window.groots, jQuery ));
